import React from 'react';
import {  } from "react-icons/bs";
import List from './user/List'
import Header from '../components/Header'
import { getUserFromToken } from '../components/authHelper';
import {

} from '@chakra-ui/react';

function User({ header }) {
  const user = getUserFromToken();
  const id = user.customer_id
  return (
    <>
      <Header header={header}/>
     
        <List customer_id={id} />
      

    </>
  );
}

export default User;